<!-- src/app/pages/shared/badges-sheet/badges-sheet.component.html -->
<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      <div class="flex flex-col">
        <span class="text-lg font-bold text-surface-900 dark:text-surface-50">Meine Badges</span>
        <span class="text-xs text-surface-600 dark:text-surface-400 mt-0.5">
          {{ getAchievedBadges().length }} von {{ badges.length }} erreicht
        </span>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="badges-sheet-content">
  <!-- Loading State -->
  <div *ngIf="isLoading && badges.length === 0" class="p-4 space-y-2">
    <div *ngFor="let i of [1,2,3,4,5]" class="flex items-center gap-3 p-3">
      <ion-skeleton-text animated style="width: 48px; height: 48px; border-radius: 50%;"></ion-skeleton-text>
      <div class="flex-1">
        <ion-skeleton-text animated style="width: 60%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 40%; height: 12px;"></ion-skeleton-text>
      </div>
      <ion-skeleton-text animated style="width: 64px; height: 24px;"></ion-skeleton-text>
    </div>
  </div>

  <!-- Badges List -->
  <div *ngIf="!isLoading || badges.length > 0" class="divide-y divide-surface-200 dark:divide-surface-700">
    <!-- In Progress Badges -->
    <div
      *ngFor="let badge of getUnachievedBadges()"
      class="px-4 py-2.5 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors cursor-pointer active:bg-surface-100 dark:active:bg-surface-900"
      (click)="viewBusinessHub(badge.businessHubId!)">
      
      <div class="flex items-center gap-2.5">
        <!-- Badge Icon -->
        <div
          class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
          [style.background]="badge.config.badgeColor + '30'">
          <i
            [class]="'pi ' + badge.config.badgeIcon"
            [style.color]="badge.config.badgeColor"
            class="text-sm"></i>
        </div>

        <!-- Badge Details -->
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-surface-900 dark:text-surface-50 truncate">
            {{ badge.config.badgeName }}
          </p>
          <div class="flex items-center gap-2 mt-0.5">
            <!-- Business Hub Avatar & Name -->
            <img
              *ngIf="badge.businessHubAvatar"
              [src]="badge.businessHubAvatar"
              [alt]="badge.businessHubName"
              class="w-3.5 h-3.5 rounded-full object-cover">
            <p class="text-xs text-surface-500 dark:text-surface-400 truncate">
              {{ badge.businessHubName }}
            </p>
            <!-- Progress Badge -->
            <span class="text-[10px] px-1.5 py-0.5 rounded-full bg-surface-100 dark:bg-surface-800 text-surface-600 dark:text-surface-400">
              {{ badge.progressPercentage.toFixed(0) }}%
            </span>
          </div>
        </div>

        <!-- Bonus Amount -->
        <div class="text-right flex-shrink-0">
          <p class="text-sm font-bold text-primary-600 dark:text-primary-400">
            +{{ badge.config.bonusCoins }}
          </p>
          <p class="text-[10px] text-surface-500 dark:text-surface-400">SC</p>
        </div>
      </div>
    </div>

    <!-- Achieved Badges -->
    <div
      *ngFor="let badge of getAchievedBadges()"
      class="px-4 py-2.5 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors cursor-pointer active:bg-surface-100 dark:active:bg-surface-900"
      (click)="viewBusinessHub(badge.businessHubId!)">
      
      <div class="flex items-center gap-2.5">
        <!-- Badge Icon with Check -->
        <div
          class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 relative"
          [style.background]="badge.config.badgeColor">
          <i
            [class]="'pi ' + badge.config.badgeIcon"
            class="text-sm text-white"></i>
          <i class="pi pi-check-circle absolute -top-0.5 -right-0.5 text-green-500 bg-white dark:bg-surface-900 rounded-full text-[10px]"></i>
        </div>

        <!-- Badge Details -->
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-surface-900 dark:text-surface-50 truncate">
            {{ badge.config.badgeName }}
          </p>
          <div class="flex items-center gap-2 mt-0.5">
            <!-- Business Hub Avatar & Name -->
            <img
              *ngIf="badge.businessHubAvatar"
              [src]="badge.businessHubAvatar"
              [alt]="badge.businessHubName"
              class="w-3.5 h-3.5 rounded-full object-cover">
            <p class="text-xs text-surface-500 dark:text-surface-400 truncate">
              {{ badge.businessHubName }}
            </p>
            <!-- Achievement Date -->
            <span class="text-[10px] px-1.5 py-0.5 rounded-full bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400">
              {{ formatDate(badge.achievedAt) }}
            </span>
          </div>
        </div>

        <!-- Bonus Amount -->
        <div class="text-right flex-shrink-0">
          <p
            class="text-sm font-bold"
            [style.color]="badge.config.badgeColor">
            +{{ badge.config.bonusCoins }}
          </p>
          <p class="text-[10px] text-surface-500 dark:text-surface-400">SC</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div
    *ngIf="!isLoading && badges.length === 0"
    class="p-8 text-center">
    <div class="w-16 h-16 mx-auto mb-3 rounded-full bg-surface-100 dark:bg-surface-800 flex items-center justify-center">
      <i class="pi pi-trophy text-2xl text-surface-400"></i>
    </div>
    <h3 class="text-base font-semibold text-surface-900 dark:text-surface-50 mb-1">
      Noch keine Badges
    </h3>
    <p class="text-sm text-surface-600 dark:text-surface-400">
      Kaufe bei deinen Lieblingsgeschäften ein, um Badges zu sammeln!
    </p>
  </div>
</ion-content>